import HttpHelper from "../../helper";

export const gymWorkoutEndpoints = {
    getGymWorkout: (msisdn) =>
        HttpHelper.fitnessAxios
            .get(`/workout/get/gym/today/${msisdn}`,)
            .then((res) => res?.data),
};